import './ServiceRequestLogBook.css';

import 'flatpickr/dist/themes/light.css';
import InputWidget from '../../../lib/InputWidget/InputWidget';
import SelectWidget from '../../../lib/SelectWidget/SelectWidget';
import {
  getServiceRequestDetailsAction,
  pushViewAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {postAPICall} from '../../../services/apiCallsHandler';
import {
  GERMANY_COUNTRY_CODE,
  SPAIN_COUNTRY_CODE,
  SUPPORTED_COUNTRY_LIST,
  UK_COUNTRY_CODE,
} from '../../../utils/constant';
import {enqueueToastUI, replaceTranslations} from '../../../utils/util';
import AssetMultiselectDropDown from '../AssetMultiselectDropDown/AssetMultiselectDropDown';

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  useToastProvider,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import countrySpecificConfig from './ServiceRequestLogBook.json';

const ServiceRequestLogBook = (props) => {
  const {t} = useTranslation();

  const dropDownItem = [
    {label: t('SPAIN'), value: SPAIN_COUNTRY_CODE},
    {label: t('GERMANY'), value: GERMANY_COUNTRY_CODE},
    {label: t('UNITED_KINGDOM'), value: UK_COUNTRY_CODE},
  ];

  const [reasonType, setReasonType] = React.useState(
    'Registration/Change registration'
  );
  const [assetsList, setAssetsList] = React.useState([]);
  const [selectedAssetsList, setSelectedAssetsList] = React.useState([]);
  const [newKeeper, setNewKeeper] = React.useState('');
  const [logBookType, setLogBookType] = React.useState('Dealer');

  const [bureauName, setBureauName] = React.useState('');
  const [street, setStreet] = React.useState('');
  const [buildingNumber, setBuildingNumber] = React.useState('');
  const [zipcode, setZipcode] = React.useState('');
  const [city, setCity] = React.useState('');

  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [reasonOptions, setReasonOptions] = React.useState([]);

  const [selectedCountry, setSelectedCountry] = React.useState(
    SUPPORTED_COUNTRY_LIST.includes(props.country)
      ? props.country
      : SPAIN_COUNTRY_CODE
  );

  const {enqueueToast} = useToastProvider();

  React.useEffect(() => {
    setReasonType('Registration/Change registration');
    if (logBookType) {
      setReasonOptions(
        countrySpecificConfig[props.country]?.reasonTypes[logBookType]
      );
    }
  }, [logBookType]);

  React.useEffect(() => {
    if (props.contractNumber && props.contractDetails) {
      setSelectedAssetsList([]);
      let assetsDetails = props.contractDetails[props.contractNumber]?.assets;

      let modelList = [];
      modelList = assetsDetails?.map((asset) => asset.description);
      setAssetsList(modelList);
    }
  }, [props.contractDetails, props.contractNumber]);

  const updateSubmitDisabledState = () => {
    if (
      reasonType === 'Registration/Change registration' &&
      newKeeper.length === 0
    ) {
      setSubmitDisabled(true);
    } else {
      setSubmitDisabled(false);
    }
  };

  React.useEffect(() => {
    if (logBookType == 'Dealer' && selectedAssetsList.length > 0) {
      updateSubmitDisabledState();
    } else if (
      bureauName.length > 0 &&
      street.length > 0 &&
      buildingNumber.length > 0 &&
      city.length > 0 &&
      selectedAssetsList.length > 0 &&
      zipcode.length === countrySpecificConfig[props.country]?.zip?.maxLength
    ) {
      updateSubmitDisabledState();
    } else {
      setSubmitDisabled(true);
    }
    if (reasonType !== 'Registration/Change registration') {
      setNewKeeper('');
    }
  }, [
    street,
    city,
    zipcode,
    bureauName,
    buildingNumber,
    newKeeper,
    logBookType,
    reasonType,
    selectedAssetsList,
  ]);

  const zipRegEx = {
    es: /\D/g,
    gb: /[^a-zA-Z0-9]/g,
    de: /\D/g,
  };

  const assetsListChangeHandler = (event) => {
    const {options} = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setSelectedAssetsList(value);
  };

  const zipCodeChangeHandler = (e) => {
    const regex = zipRegEx[props.country];
    const cleanedValue = e.replace(regex, '');
    setZipcode(cleanedValue);
  };
  const onBureauNameChangeHandler = (value) => {
    setBureauName(value);
  };

  const onAddressStreetChangeHandler = (value) => {
    setStreet(value);
  };

  const onBuldingChangeHandler = (value) => {
    setBuildingNumber(value);
  };

  const onZipChangeHandler = (value) => {
    if (value.length <= countrySpecificConfig[props.country]?.zip?.maxLength) {
      zipCodeChangeHandler(value);
    }
  };

  const onAddressCityChangeHandler = (value) => {
    setCity(value);
  };

  const formFields = [
    {
      label: 'NAME_REGISTARTION_BUREAU',
      type: 'text',
      required: true,
      id: 'log-book-bureau-name',
      value: bureauName,
      setValue: onBureauNameChangeHandler,
      error: bureauName.length > 0,
      helperText: 'NAME_BUREAU_MANDATORY',
    },
    {
      label: 'CHANGE_ADDRESS_STREET',
      type: 'text',
      required: true,
      id: 'log-book-street',
      value: street,
      setValue: onAddressStreetChangeHandler,
      error: street.length > 0,
      helperText: 'STREET_MANDATORY',
    },
    {
      label: 'CHANGE_ADDRESS_HOUSE_NUMBER',
      type: 'text',
      required: true,
      id: 'log-book-building-number',
      value: buildingNumber,
      setValue: onBuldingChangeHandler,
      error: buildingNumber.length > 0,
      helperText: 'HOUSE_MANDATORY',
    },
    {
      label: 'CHANGE_ADDRESS_ZIPCODE',
      type: 'text',
      required: true,
      id: 'log-book-zipcode',
      value: zipcode,
      setValue: onZipChangeHandler,
      error:
        zipcode.length == countrySpecificConfig[props.country]?.zip?.maxLength,
      helperText: 'ZIPCODE_MANDATORY',
    },
    {
      label: 'CHANGE_ADDRESS_CITY',
      type: 'text',
      required: true,
      id: 'log-book-city',
      value: city,
      setValue: onAddressCityChangeHandler,
      error: city.length > 0,
      helperText: 'CITY_MANDATORY',
    },
  ];

  const getCountryBasedFormFields = (fieldsConfig, countryFields) => {
    return fieldsConfig.filter((fieldConfig) => {
      return Object.values(countryFields).includes(fieldConfig.label);
    });
  };

  const countryFormFields = getCountryBasedFormFields(
    formFields,
    countrySpecificConfig[props.country]?.fields
  );

  const formButtonControls = () => {
    return (
      <div className="buttonControls">
        <Button
          id="cancelButton"
          onClick={() => props.cancelButtonClick(null)}
          variant="secondary"
        >
          {t('CANCEL')}
        </Button>

        <Button
          type="submit"
          disabled={submitDisabled}
          id="logBookPrimaryBtn"
          variant="primary"
          startIcon={
            loader && <CircularProgress size="small" style={{color: '#000'}} />
          }
        >
          {t('SUBMIT')}
        </Button>
      </div>
    );
  };

  const logBookSubmitHandler = (e) => {
    const reqBody = {};
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }
    if (logBookType == 'Registration bureau') {
      reqBody.bureauName = bureauName;
      reqBody.street = street;
      reqBody.buildingNumber = buildingNumber;
      reqBody.zipcode = zipcode;
      reqBody.city = city;
      reqBody.selectedCountry = selectedCountry;
    }

    e.preventDefault();
    setSubmitDisabled(true);
    setLoader(true);
    postAPICall(
      'serviceRequest',
      {
        requestType: 'Log Book',
        contractNumber: props.contractNumber,
        logBookType: logBookType,
        reasonType: reasonType,
        newKeeper: newKeeper,
        assetsList: selectedAssetsList.join(','),
        countryCode: props.country,
        userEmail: props.userDetails.email,
        ...reqBody,
      },
      {
        errorTag: 'LOG_BOOK_SERVICE_REQUEST',
      }
    ).then((res) => {
      setLoader(false);
      setSubmitDisabled(false);
      if (res.status == 200) {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        appStore.dispatch(pushViewAction('serviceRequestDashboard'));
      }
      if (res.status === 429) {
        enqueueToastUI(
          res.status,
          enqueueToast,
          null,
          replaceTranslations(t('SERVICE_REQUEST_LIMIT'), 50, t('SETTLEMENT_QUOTE'))
        );
      } else {
        enqueueToastUI(
          res.status,
          enqueueToast,
          t('SERVICE_REQUEST_SUCCESS'),
          t('SERVICE_REQUEST_CREATION_FAILED')
        );
      }
    });
  };

  return (
    <div className={'ServiceRequestChangePhoneWrapper'}>
      <div className={'ServiceRequestCard'}>
        <div className="serviceRequestHeader">
          <div className={'title'}>{t('LOG_BOOK_REQUEST')}</div>
        </div>
        <div className={'subTitle'}>{t('LOG_BOOK_REQUEST_SUBTITLE')}</div>
      </div>
      <Box pl={4} pr={4} pb={4}>
        <form onSubmit={logBookSubmitHandler}>
          <Card className="logBookCardCustom ">
            <CardContent className="LogBookCard">
              <div className={'subTitle'}>
                <AssetMultiselectDropDown
                  label={t('LOGBOOK_MODEL_NUMBER')}
                  value={selectedAssetsList}
                  hasSelectAll={true}
                  onChangeHandler={assetsListChangeHandler}
                  helperText={t('LOGBOOK_MODEL_NUMBER_HELPERTEXT')}
                  optionData={assetsList ?? []}
                  required={true}
                  setSelectedAssetsList={setSelectedAssetsList}
                />
                <Typography gutterBottom variant="h5" required={true}>
                  {t('LOG_BOOK_CHOOSE_OPTION')}
                  <span className="datepicker-asterisk">*</span>
                </Typography>
                <RadioGroup
                  name="group1"
                  data-testid="radio-button-id"
                  className="logBookType"
                  defaultValue={logBookType}
                  onClick={(e) => setLogBookType(e.target.value)}
                >
                  <FormControlLabel
                    control={<Radio />}
                    label={t('LOG_BOOK_DEALER')}
                    value="Dealer"
                  />
                  <FormControlLabel
                    control={<Radio />}
                    label={t('LOG_BOOK_REGISTRATION_BUREAU')}
                    value="Registration bureau"
                  />
                </RadioGroup>
              </div>

              {logBookType == 'Registration bureau' && (
                <div className="LogBookAddressSection">
                  <Typography className="log-book-beauro-header">
                    {t('REGISTRATION_BEAURO_HEADER')}
                  </Typography>
                  <div className="ChangeAddressCard">
                    {countryFormFields.map((i, index) => (
                      <InputWidget
                        key={i.id}
                        required={i.required}
                        type={i.type}
                        id={i.id}
                        label={t(i.label)}
                        value={i.value}
                        setValue={i.setValue}
                        customError={true}
                        error={i.error}
                        helperText={t(i.helperText)}
                      />
                    ))}
                    <div>
                      <SelectWidget
                        id="change-address-country"
                        label={t('CHANGE_ADDRESS_COUNTRY')}
                        changeHandler={setSelectedCountry}
                        data={dropDownItem}
                        defaultValue={selectedCountry}
                        required={true}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              )}
              <Typography className="log-book-beauro-header">
                {t('LOG_BOOK_BEAURO_HEADER')}
              </Typography>
              <div className="LogBookContainer">
                <div className="LogBookReasonWrapper">
                  <SelectWidget
                    id="logbook-reason"
                    label={t('LOG_BOOK_REASON_TYPE')}
                    changeHandler={setReasonType}
                    data={reasonOptions}
                    defaultValue={reasonType}
                    value={reasonType}
                    required={true}
                    className={'reasonType'}
                    helperText={t('LOG_BOOK_REASON_HELPER_TEXT')}
                  />
                </div>
                <div className="LogBookReasonWrapperSecond">
                  {reasonType == 'Registration/Change registration' && (
                    <InputWidget
                      label={t('LOG_BOOK_BEAURO_NAME')}
                      type="text"
                      data-testid="log-book-beauro-name"
                      id="log-book-beauro-name"
                      required={true}
                      value={newKeeper}
                      setValue={setNewKeeper}
                      customError={true}
                      error={newKeeper.length > 0}
                      helperText={t('LOG_BOOK_BEAURO_NAME_MANDATORY')}
                    />
                  )}
                </div>
              </div>
            </CardContent>
          </Card>

          {formButtonControls()}
        </form>
      </Box>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contractDetails: state.appStates.contractDetails?.accountDetails,
    userDetails: state.appStates.userDetailsInfo,
  };
};

export default connect(mapStateToProps)(ServiceRequestLogBook);
